import React, { PropsWithChildren, useRef } from 'react'
import { Button } from '@chakra-ui/react'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogOverlay,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogProps,
} from '@chakra-ui/react'

interface Props extends Omit<AlertDialogProps, 'leastDestructiveRef'> {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => Promise<void>
    isLoading?: boolean
    title: string
    isConfirmDisabled?: boolean
}

export default function ActionConfirmation({
    isOpen,
    onClose,
    onConfirm,
    title,
    children,
    isLoading,
    isConfirmDisabled,
    ...props
}: PropsWithChildren<Props>) {
    const leastDestructiveRef = React.useRef(null)

    return (
        <AlertDialog
            isOpen={isOpen}
            onClose={onClose}
            leastDestructiveRef={leastDestructiveRef}
            {...props}
        >
            <AlertDialogOverlay />
            <AlertDialogContent>
                <AlertDialogHeader>{title}</AlertDialogHeader>
                <AlertDialogBody mb={2}>{children}</AlertDialogBody>
                <AlertDialogFooter justifyContent="space-between">
                    <Button
                        ref={leastDestructiveRef}
                        isDisabled={isLoading}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirm}
                        colorScheme="brand"
                        isLoading={isLoading}
                        isDisabled={isConfirmDisabled}
                    >
                        Confirm
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
